import axios, {AxiosResponse} from "axios";
import {OrderTaskImport, Task, TaskRequest} from "@/model/OrderTaskImport";

const PATH = "/order-task";
const PATH_IMPORT = `${PATH}/import`;
const PATH_V2 = "/v2/tasks";
const PATH_ORDERS_V2 = "/v2/orders";

class OrderTaskService {

    // region ORDER TASK IMPORT
    getOrderTaskImportByOrderId(orderId: number): Promise<AxiosResponse<OrderTaskImport>> {
        return axios.get(`${PATH_IMPORT}/order/${orderId}`);
    }

    createOrderTaskImport(payload: OrderTaskImport): Promise<AxiosResponse<OrderTaskImport>> {
        return axios.post(PATH_IMPORT, payload, {headers: {"Content-Type": "application/json"}});
    }

    deleteOrderTaskImport(id: number): Promise<AxiosResponse<null>> {
        return axios.delete(`${PATH_IMPORT}/${id}`);
    }

    // endregion

    // region TASK (v2), addressed by uuids
    findTasks(date: string): Promise<AxiosResponse<{ tasks: Array<Task> }>> {
        return axios.get(PATH_V2, {
            params: {
                date: date
            }
        });
    }

    addTask(orderUuid: string, request: TaskRequest): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_ORDERS_V2}/${orderUuid}/tasks`, request);
    }

    updateTask(taskUuid: string, request: TaskRequest): Promise<AxiosResponse<Task>> {
        return axios.put(`${PATH_V2}/${taskUuid}`, request);
    }

    completeTask(taskUuid: string): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_V2}/${taskUuid}/complete`);
    }

    reopenTask(taskUuid: string): Promise<AxiosResponse<Task>> {
        return axios.post(`${PATH_V2}/${taskUuid}/reopen`);
    }

    // endregion
}

export default new OrderTaskService();
